import React from "react";
interface IconProps {
	fill: string;
	class?: string;
	className?: string;
	height: number;
}


export const EcoSunIcon = (props: IconProps) => (
	<svg fill={props.fill} className={props.class} viewBox="0 0 233 190" width={props.height} height={props.height} >
		<g>
			<path d="M 225.893,10.001227 H 7.5 c -4.143,0 -7.5,3.357999 -7.5,7.499999 V 158.84422 c 0,4.142 3.357,7.5 7.5,7.5 h 46.803 l 15.907,0.001 h 43.494 l 15.907,10e-4 h 43.497 l 15.906,0.001 h 36.878 c 4.143,0 7.5,-3.358 7.5,-7.5 V 17.501226 c 0.001,-4.142 -3.357,-7.499999 -7.499,-7.499999 z m -7.5,141.342993 H 194.473 178.566 135.07 119.163 75.668 59.762 15 V 25.001226 h 203.393 z" />
			

		</g>
		<g transform="matrix(0.39378209,0,0,0.39378209,67.347066,44.445285)">
			<path
     id="path2-7"
     d="m 116.211,194.8 c -4.143,0 -7.5,3.357 -7.5,7.5 v 22.643 c 0,4.143 3.357,7.5 7.5,7.5 4.143,0 7.5,-3.357 7.5,-7.5 V 202.3 c 0,-4.143 -3.357,-7.5 -7.5,-7.5 z" /><path
     id="path4"
     d="m 116.211,37.645 c 4.143,0 7.5,-3.357 7.5,-7.5 V 7.505 c 0,-4.143 -3.357,-7.5 -7.5,-7.5 -4.143,0 -7.5,3.357 -7.5,7.5 v 22.641 c 0,4.142 3.357,7.499 7.5,7.499 z" /><path
     id="path6"
     d="m 50.054,171.78 -16.016,16.008 c -2.93,2.929 -2.931,7.677 -0.003,10.606 1.465,1.466 3.385,2.198 5.305,2.198 1.919,0 3.838,-0.731 5.302,-2.195 l 16.016,-16.008 c 2.93,-2.929 2.931,-7.677 0.003,-10.606 -2.93,-2.931 -7.679,-2.932 -10.607,-0.003 z" /><path
     id="path8"
     d="m 177.083,62.852 c 1.919,0 3.838,-0.731 5.302,-2.195 L 198.4,44.649 c 2.93,-2.929 2.931,-7.677 0.003,-10.606 -2.93,-2.932 -7.679,-2.931 -10.607,-0.003 L 171.78,50.048 c -2.93,2.929 -2.931,7.677 -0.003,10.607 1.466,1.465 3.386,2.197 5.306,2.197 z" /><path
     id="path10"
     d="m 37.645,116.224 c 0,-4.143 -3.357,-7.5 -7.5,-7.5 H 7.5 c -4.143,0 -7.5,3.357 -7.5,7.5 0,4.143 3.357,7.5 7.5,7.5 h 22.645 c 4.142,0 7.5,-3.358 7.5,-7.5 z" /><path
     id="path12"
     d="m 224.947,108.724 h -22.652 c -4.143,0 -7.5,3.357 -7.5,7.5 0,4.143 3.357,7.5 7.5,7.5 h 22.652 c 4.143,0 7.5,-3.357 7.5,-7.5 0,-4.143 -3.357,-7.5 -7.5,-7.5 z" /><path
     id="path14"
     d="m 50.052,60.655 c 1.465,1.465 3.384,2.197 5.304,2.197 1.919,0 3.839,-0.732 5.303,-2.196 2.93,-2.929 2.93,-7.678 10e-4,-10.606 L 44.652,34.042 c -2.93,-2.93 -7.679,-2.929 -10.606,-0.001 -2.93,2.929 -2.93,7.678 -10e-4,10.606 z" /><path
     id="path16"
     d="m 182.395,171.782 c -2.93,-2.929 -7.679,-2.93 -10.606,-0.001 -2.93,2.929 -2.93,7.678 -10e-4,10.607 l 16.007,16.008 c 1.465,1.465 3.384,2.197 5.304,2.197 1.919,0 3.839,-0.732 5.303,-2.196 2.93,-2.929 2.93,-7.678 0.001,-10.607 z" /><path
     id="path18"
     d="m 116.22,48.7 c -37.232,0 -67.523,30.291 -67.523,67.523 0,37.232 30.291,67.523 67.523,67.523 37.232,0 67.522,-30.291 67.522,-67.523 0,-37.232 -30.29,-67.523 -67.522,-67.523 z m 0,120.047 c -28.962,0 -52.523,-23.561 -52.523,-52.523 0,-28.962 23.561,-52.524 52.523,-52.524 28.961,0 52.522,23.562 52.522,52.523 0,28.961 -23.561,52.524 -52.522,52.524 z" />
		</g>

	</svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/EcoSun.tsx